module.exports = __webpack_public_path__ + "img/cisv_logo.4220d68d.png";